import domtoimage from "dom-to-image";

class Preview {

    constructor() {

        this.elements = '.personalizator__product-image-content';
        this.previewButton = '#personalizator__preview';
        this.previewModal = '#preview-modal';

        this.bindClick();
        this.listenSrcTrigger()

    }

    bindClick() {

        $(document).ready(() => {

            $(this.previewButton).on('click', (event) => {

                this.showModal();

                setTimeout(() => {

                    $(this.elements).each(async(index, element) => {

                        $(element).addClass('active');
    
                        if($(element).data('type') !== 'front') {
                            $(element).css('opacity', '0.01');
                        }
    
                        this.toggleElementAssets(element, false);
    
                        let elementHtml = $(element).find('.personalizator__product-image-content-icon')[0];
    
                        return await this.createPreview(elementHtml, element);
    
                    });

                }, 1000);

            });

        });

    }


    toggleElementAssets(element, show) {

        $(element).find('.remove').toggle();
        $(element).find('.ui-resizable-handle').toggle();
        $(element).find('.ui-rotatable-handle').toggle();

        if (show) {

            $(element).find('.personalizator__fly').css('border-color', '#000');

        } else {

            $(element).find('.personalizator__fly').css('border-color', 'transparent');

        }

    }


    showModal() {

        $(this.elements).each((index, element) => {

            $(`.personalizator__modal-content-item-${$(element).data('type')}`).attr('src', null).addClass('hidden');
            $(`.personalizator__modal-content-item-${$(element).data('type')}`).parent().find('.loading').show();

        });

        $(this.previewModal).addClass('dialog--show');
    }

    listenSrcTrigger() {

        $(document).ready(() => {

            $('.personalizator__modal-content-item img').on('change', (event) => {

                $(event.currentTarget).removeClass('hidden');
                $(event.currentTarget).parent().find('.loading').hide();

            });

        })

    }

    async createPreview(elementHtml, element) {


        if(elementHtml) {
            const test = await html2canvas(elementHtml)
                .then(dataUrl => {
                    $(element).find('.previewInput').val(dataUrl.toDataURL("image/png"));
                    this.toggleElementAssets(element, true);
                    $(`.personalizator__modal-content-item-${$(element).data('type')}`).attr('src', dataUrl.toDataURL("image/png")).trigger('change');

                    $('.personalizator__navs-item').removeClass('active');
                    $('[data-tab=".personalizator__front"]').addClass('active');
                    $('[data-tab="#personalizator__insert-front-text"]').addClass('active');
                    $('#personalizator__insert-front-text').addClass('active');
                    
                    if($(element).data('type') !== 'front') {
                        $(element).removeClass('active').css('opacity', 1);
                    }
                });

            return test;
        }

    }

}

export const preview = new Preview();
